import React, { Component } from "react";

import styled from "styled-components";
import { Button, Card, CardBody, Col, Container, Form, Row } from "reactstrap";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import { deleteClient, getClientsList } from "../../../store/clients/actions";

import { Link } from "react-router-dom";
import ReactSelect from "react-select";
import ModifiedMetaTags from "../../../components/ModifiedMetaTags";

class ClientsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      selectedStatus: {},
      statuses: [
        { label: "Active", value: 4 },
        { label: "Not active", value: -3 },
        { label: "New", value: 1 },
        { label: "Signing contract", value: 2 },
        { label: "integration", value: 3 },
        { label: "Deffered", value: -1 },
        { label: "On hold", value: -2 },
      ],
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.handleSelectStatus(this.state.statuses[0], 'init');
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleTableChange = data => {
    let dt = data;
    dt["status"] = this.state.selectedStatus?.value;
    this.props.getClientsList(dt);
  };

  handleSelectStatus = (item, status) => {
    let dt = this.props.data;
    dt["status"] = item.value;
    dt["page"] = 1;
    if (status === 'init') { dt["search"] = ''; }
    this.setState({ ...this.state, selectedStatus: item });
    this.props.getClientsList({ ...dt });
  };

  render() {
    const statusFormatter = (cell, row, rowIndex, formatExtraData) => {
      let status;
      switch (row.status_label.toLowerCase()) {
        case "new":
          status = "bg-primary";
          break;
        case "active":
          status = "bg-success";
          break;
        default:
          status = "bg-info";
          break;
      }
      return (
        <span className={`badge ${status} font-size-12`}>
          {row.status_label}
        </span>
      );
    };

    const legalNameFormatter = (cell, row) => {
      return (
        <LegalNameLink to={`/clients/${row.id}`}>
          {row.real_name || 'N\\A'}
        </LegalNameLink>
      );
    };

    const columns = [
      {
        dataField: "real_name",
        text: "Client name",
        sort: true,
        formatter: legalNameFormatter,
      },
      // {
      //   dataField: "budget",
      //   text: "Budget",
      //   sort: true,
      // },
      {
        dataField: "status",
        text: "Status",
        sort: true,
        formatter: statusFormatter,
      },
      {
        dataField: "created_at",
        text: "Created",
        sort: true,
      },
    ];

    const onClickRow = (e, row) => {
      this.props.history.push(`/clients/${row.id}`);
    };

    const onClickAddClient = () => {
      this.props.history.push(`/clients/add`);
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Clients list | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Clients"
              link="/dashboard"
            />
            <StyledRow>
              <div className="col-12">
                <StyledCard>
                  <CardBody
                    style={{
                      padding: "1.25rem 0",
                    }}
                  >
                    <FilterContainer className="d-flex justify-content-between align-items-end">
                      <div>
                        <Form className="row gy-2 gx-3 align-items-center">
                          <div className="col-sm-auto">
                            <span>{"Filter by"}:</span>
                          </div>
                          <div className="col-sm-auto">
                            <CustomSelect
                              defaultValue={this.state.statuses[0]}
                              value={this.state.selectedStatus}
                              onChange={this.handleSelectStatus}
                              options={
                                this.state.statuses.map(i => {
                                  return {
                                    label: i.label,
                                    value: i.value,
                                  };
                                }) || []
                              }
                              classNamePrefix="select2-selection"
                              isLoading={this.props.loading}
                              required
                            />
                          </div>
                        </Form>
                      </div>
                    </FilterContainer>
                  </CardBody>
                </StyledCard>
              </div>
            </StyledRow>

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions?.["add_clientmodel"] && (
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2 me-2"
                          onClick={onClickAddClient}
                        >
                          <i className="mdi mdi-plus me-1" /> Add client
                        </Button>
                      )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const CustomSelect = styled(ReactSelect)`
  min-width: 240px;
`;

const FilterContainer = styled.div`
  flex-wrap: wrap;
  gap: 20px;

  & > div {
    flex: 1 1 300px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

const LegalNameLink = styled(Link)`
  transition-duration: 0.1s;
  color: #495057;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

ClientsList.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  getClientsList: PropTypes.func.isRequired,
  deleteClient: PropTypes.func.isRequired,
  history: PropTypes.any,
  permissions: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  data: state.Clients.data,
  loading: state.Clients.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, { getClientsList, deleteClient })(
  ClientsList
);
